import { HelpCircle, Info, MapPin, Smile } from 'react-feather';
import { ReactNode } from 'react';
import { TFunction } from 'i18next';

import { PracticalInfoTopic } from '__generated__/graphql';

import UI from './UI';

// Preset practical info topics store their slug as the title; the label is translated client-side and never stored.
export const getPracticalInfoFactTitle = (title: string, topics: PracticalInfoTopic[], t: TFunction) => (
  topics.includes(title as PracticalInfoTopic) ? t(`common:practical_info.${title}`) : title
);

export const PracticalInfoIcon = ({ topic }: { topic: string; }) => {
  const icons: Record<string, ReactNode> = {
    registration: <UI.Icons.Ticket />,
    start_finish: <UI.Icons.StartFinish />,
    location: <MapPin />,
    course: <UI.Icons.Course />,
    facilities: <UI.Icons.Facilities />,
    volunteers: <Smile />,
    contact: <HelpCircle />,
  };

  return (
    <>{icons[topic] || <Info />}</>
  );
};

export default undefined;
